import type { RouteObject } from 'react-router';

import { IndexPage } from './Index';

/**
 * The console entry. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so this route
 * adds no loader of its own. The guard decides **navigation**; every figure this
 * page renders is authorized by `backend-analytics` on the request itself, and
 * the origin the call arrives from is never an authorization input.
 *
 * It carries no breadcrumb: this is the root, and there is nothing above it.
 */
export const indexRoute: RouteObject = {
  index: true,
  element: <IndexPage />,
};
